import Marquee from "react-fast-marquee";

const ITEMS = [
  "POST-IRONIC APPAREL",
  "SS26 COLLECTION 001",
  "VOID-DYED ORGANIC",
  "MADE IN THE VOID",
  "ANTI-COMMODITY FASHION",
  "WEAR THE ABSENCE",
  "DROP 001 NOW LIVE",
];

export default function BrandMarquee({ speed = 35 }) {
  return (
    <div
      data-testid="brand-marquee"
      className="border-y border-[#262626] bg-black py-4 overflow-hidden"
    >
      <Marquee speed={speed} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-3xl tracking-tight px-8 inline-flex items-center"
          >
            {t}
            <span className="text-[#ff1493] ml-8">×</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
